import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';

import {useLazyWorkspaceInfoQuery} from '@dms/api/core';
import {appWorkspaceKey} from '@dms/config';
import {
  getWorkspaceFromUri,
  redirectToWorkspace,
  resetPasswordRoute,
  userInvitationRoute,
} from '@dms/routes';
import {CommonSkeleton} from '@dms/shared';

import {isRunningInCypress, useNavigate} from 'shared/web';

const REDIRECT_ONLY_ROUTES: string[] = [resetPasswordRoute, userInvitationRoute];

export function WorkspaceInit() {
  const {workspace, shouldRedirectToAppWorkspace, isReviewApp} = getWorkspaceFromUri();
  const [getWorkspaceInfo, {data: workspaceInfo}] = useLazyWorkspaceInfoQuery();
  const navigate = useNavigate();

  useEffect(
    function verifyWorkspace() {
      if (isRunningInCypress() || isReviewApp) {
        return;
      }

      if (!workspace || shouldRedirectToAppWorkspace) {
        redirectToWorkspace();
        return;
      }

      // Redirect-only pages leave the app immediately; probing workspace-info here races
      // that navigation — Safari cancels the in-flight fetch and the .catch() would hijack
      // the redirect (T20-133450).
      if (REDIRECT_ONLY_ROUTES.includes(window.location.pathname)) {
        return;
      }

      if (!workspaceInfo && !shouldRedirectToAppWorkspace && workspace !== appWorkspaceKey) {
        getWorkspaceInfo({workspace})
          .unwrap()
          .catch(() => {
            redirectToWorkspace();
          });
        return;
      }
    },
    [workspaceInfo, getWorkspaceInfo, navigate] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );

  if (shouldRedirectToAppWorkspace) {
    return <CommonSkeleton />;
  }

  return <Outlet />;
}
